import React from 'react';

'use strict';

export default class IframeViewer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false, loading: false };
    }

    componentDidMount() {
        if (!this.state.loaded)
            this.loadData();
    }

    loadData() {
        fetch(this.props.metadataUrl)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        loading: false,
                        loaded: true,
                        metadata: result
                    });
                },
                (error) => {
                    this.setState({
                        loading: false,
                        loaded: false
                    });
                }
            );
    }

    render() {
        return this.state.loading ?
            "Loading..." :
            this.state.loaded ?
                React.createElement(
            'iframe',
                    {
                        src: this.state.metadata.url,
                        style: { border: 0, position: 'absolute', width: '100%', height: '100%' }
                    }
                ) :
                null
    }
}